/**
 * =================
 * NAVIGATION
 * tool
 * =================
 */
app.navigation = (function(module) {

	var ESC_keyCode = 27;

	// staff
	var $win = app.$(window),
		  $dummy;

	module.init = function() {		
    _setNavigation();
		_bindNavigationEvent();
	};

	module.getEvents = _getEvents;

	// fn's
	function _getEvents() {
    return ['openNavigation', 'closeNavigation'].toString().split(',');
  }

  function _setNavigation() {
    $dummy = app.$('<div class="navigation-pane-overlay" />').appendTo('body');
  }

  function _bindNavigationEvent() {
    app.$(document).on('click', '.navigation-pane-overlay', _onOverlayClick);

    $win
      .on('openNavigation',  _onOpenNavigation)
      .on('closeNavigation', _onCloseNavigation)
      .on('keyup',           _onESCKeyup);
	}

	// auxiliary
  function _onOpenNavigation() {
    $dummy.addClass('active');
    app.$('body').addClass('navigation-locked');
  }

  function _onCloseNavigation() {
    app.$('body').removeClass('navigation-locked');
    $dummy.removeClass('active');
  }

  function _onESCKeyup(e) {
    e.preventDefault();

    if (e.keyCode !== ESC_keyCode) return;

    $win.trigger('closeNavigation');
  }

  function _onOverlayClick() {
    $win.trigger('closeNavigation');
  }

	return module;

}(app.navigation || {}));


/* EOF */